export const ReportsActions = {
  RetrieveReportsForUser: 'ReportsActions.RetrieveReportsForUser',
  RetrieveUserGeneratedReport: 'ReportsActions.RetrieveUserGeneratedReport',
  RetrieveUserReportEntitlements: 'ReportsActions.RetrieveUserReportEntitlements',
  SetSelectedReport: 'ReportsActions.SetSelectedReport',
  RunReport: 'ReportsActions.RunReport'
};

export const ReportsMutations = {
  SetReportsForUser: 'ReportsMutations.SetReportsForUser',
  SetUserGeneratedReport: 'ReportsMutations.SetUserGeneratedReport',
  SetReportEntitlements: 'ReportsMutations.SetReportEntitlements',
  SetSelectedReport: 'ReportsMutation.SetSelectedReport',
  UpdateReportInProgress: 'ReportsMutations.UpdateReportInProgress'
};

export const ReportsGetters = {
  ReportsForUser: 'ReportsGetters.ReportsForUser',
  UserGeneratedReport: 'ReportsGetters.UserGeneratedReport',
  Fields: 'ReportsGetters.Fields',
  IsReportInProgress: 'ReportsGetters.IsReportInProgress',
  ReportClients: 'ReportsGetters.ReportClients',
  ReportEntitlements: 'ReportsGetters.ReportEntitlements'
};
